// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + {"192":"532c4093680c923d197a","458":"889a7d1f1ef215220ced"}[chunkId] + ".js";
};